import { applyLeg } from "./legApplier";
import type { LineItem } from "./lineItemMerger";

export type CartProduct = {
  sku: string;
  selectedFabric: string;
  quantity: number;
  accessoryProducts: unknown[];
};

/**
 * Build the returnCartInfo products from line items, baking each item's chosen leg into its
 * SKU (via applyLeg). One product per line item — components are picked individually, so
 * there is no bed expansion here.
 */
export const buildProducts = (items: LineItem[]): CartProduct[] =>
  items.map((item) => ({
    sku: item.leg ? applyLeg(item.sku, item.leg.code) : item.sku,
    selectedFabric: item.fabric.sku,
    quantity: item.quantity,
    accessoryProducts: [],
  }));
